var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#0A399C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.8283 40C97.8283 40 104.192 33.6364 97.8283 27.2727L91.4646 20L70.5556 40.9091L83.2828 53.6364L97.8283 40ZM121.465 63.6364C121.465 63.6364 127.828 57.2727 121.465 50.9091L115.101 43.6364L94.1919 64.5455L106.919 77.2727L121.465 63.6364ZM84.1919 60L70.5556 72.7273L76.9192 79.0909L91.4646 93.6364L104.192 80L90.5555 66.3636L84.1919 60ZM80.5555 56.3636L67.8283 43.6364L46.9192 64.5455L59.6465 77.2727L66.9192 70.9091L80.5555 56.3636ZM84.1919 106.364L71.4646 119.091L92.3737 140L98.7374 133.636C105.101 127.273 99.6465 121.818 98.7374 120.909L84.1919 106.364ZM37.8283 73.6364C31.4646 80 37.8283 86.3636 37.8283 86.3636L52.3737 100.909L65.101 88.1818L44.1919 67.2727L37.8283 73.6364ZM94.1919 96.3636L115.101 117.273L121.465 110.909C127.828 104.545 122.374 99.0909 121.465 98.1818L106.919 83.6364L94.1919 96.3636ZM69.6465 89.0909L55.101 103.636L67.8283 116.364L88.7374 95.4545L76.0101 82.7273L69.6465 89.0909Z",
    fill: "#FF6E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcrb);
export default __webpack_public_path__ + "static/media/tcrb.80184d56.svg";
export { ForwardRef as ReactComponent };